export const getUploadUrl = (fileUploaded, path = '/admin/') => {
  const { key, filename } = fileUploaded;
  return key
    ? `https://cdn.peoplegrove.com/${encodeURI(key)}`
    : `https://cdn.peoplegrove.com${path}${encodeURI(filename)}`;
};
